import { useAgentQuery } from "web_myplann/Api/Advisor/useAgentQuery";
import { useAssignedAgentsQuery } from "web_myplann/Api/Advisor/useAssignedAgentsQuery";
import { useTaskQuery } from "web_myplann/Api/Tasks/useTaskQuery";
import { useTaskWorkflowsQuery } from "web_myplann/Api/Tasks/useTaskWorkflowsQuery";
import { UserAgentStatusEnum } from "web_myplann/Infrastructure/Api/Api";

export const useTaskDetail = (taskId: number | null) => {
	const { data: taskData, isFetching: isTaskFetching } = useTaskQuery(taskId);
	const { data: taskWorkflowsData, isFetching: isTaskWorkflowsFetching } =
		useTaskWorkflowsQuery(taskId);

	const { data: agentDetail } = useAgentQuery(taskData?.author.id);
	const { data: assignedAgents } = useAssignedAgentsQuery(
		UserAgentStatusEnum.Connected,
	);

	return {
		task: taskData ?? undefined,
		phases: taskWorkflowsData?.items ?? [],
		hasMoreAgents: (assignedAgents?.data.length ?? 0) > 1,
		isLoading: isTaskFetching || isTaskWorkflowsFetching,
		isNotFound: taskData === null,
		contactPhone: agentDetail?.phone ?? undefined,
		contactEmail: agentDetail?.email ?? undefined,
	};
};
